import { render, staticRenderFns } from "./ActionColumns.vue?vue&type=template&id=05c987a8&scoped=true"
import script from "./ActionColumns.vue?vue&type=script&lang=js"
export * from "./ActionColumns.vue?vue&type=script&lang=js"
import style0 from "./ActionColumns.vue?vue&type=style&index=0&id=05c987a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c987a8",
  null
  
)

export default component.exports